import { useTranslation as useI18nTranslation } from 'react-i18next';

export const useTranslation = () => {
  return useI18nTranslation('translation');
};
